import { Collapse } from 'bootstrap'
import { waitForElement } from '../../../js/utils'

class Header {
  constructor() {
    this.header = document.querySelector('header')

    if (!this.header) {
      return
    }

    this.render()
    window.addEventListener('resize', this._handleResize)
    setTimeout(() => this._handleResize(), 600)
  }

  render() {
    waitForElement('.en__p2p__nav__list').then(() => {
      this.addNavbarClasses()
      this.moveNavbar()
      this.makeCollapse()
    })
  }

  addNavbarClasses() {
    this.header.querySelector('.en__p2p__nav__list')?.classList.add('navbar-nav')
    this.header.querySelectorAll('.en__p2p__nav__item').forEach((item) => item.classList.add('nav-item'))
    this.header.querySelectorAll('.en__p2p__nav__item a').forEach((item) => item.classList.add('nav-link'))
  }

  moveNavbar() {
    const siteNav = this.header.querySelector('[data-en-nav="site"]')
    const navbarNav = this.header.querySelector('.navbar-nav')

    if (siteNav && navbarNav) {
      siteNav.replaceWith(navbarNav)
    }
  }

  makeCollapse() {
    new Collapse(this.header.querySelector('.navbar-collapse'), {
      toggle: false,
    })
  }

  _setLogoHeight() {
    const logo = this.header.querySelector('.navbar-brand img')

    if (logo) {
      const height = logo.height

      this.header.style.setProperty('--logo-height', `${height}px`)
    }
  }

  _setLogoWidth() {
    const logo = this.header.querySelector('.navbar-brand img')

    if (logo) {
      const width = logo.width

      this.header.style.setProperty('--logo-width', `${width}px`)
    }
  }

  _handleResize = () => {
    this._setLogoHeight()
    this._setLogoWidth()
  }
}

export default Header
